import {
	listCertificateTemplates, createCertificateTemplate, updateCertificateTemplate,
	deleteCertificateTemplate, listIssuedCertificates,
	issueCertificate, regenerateCertificatePdf, previewCertificate,
} from '@/services/academy/certificates.service'

export default {
	namespaced: true,
	state: {
		templates:       { data: [], meta: { total: 0 } },
		templatesStatus: 'init',
		issued:          { data: [], meta: { total: 0 } },
		issuedStatus:    'init',
	},
	getters: {
		getTemplates:       (s) => s.templates,
		getTemplatesStatus: (s) => s.templatesStatus,
		getIssued:          (s) => s.issued,
		getIssuedStatus:    (s) => s.issuedStatus,
	},
	mutations: {
		SET_TEMPLATES(state, v)        { state.templates = v },
		SET_TEMPLATES_STATUS(state, v) { state.templatesStatus = v },
		SET_ISSUED(state, v)           { state.issued = v },
		SET_ISSUED_STATUS(state, v)    { state.issuedStatus = v },
	},
	actions: {
		async fetchTemplates({ commit }, params) {
			commit('SET_TEMPLATES_STATUS', 'pending')
			try {
				const { data } = await listCertificateTemplates(params)
				commit('SET_TEMPLATES', data)
				commit('SET_TEMPLATES_STATUS', 'init')
			} catch {
				commit('SET_TEMPLATES_STATUS', 'error')
			}
		},
		async createTemplate({ dispatch }, data) {
			await createCertificateTemplate(data)
			dispatch('fetchTemplates')
		},
		async updateTemplate({ dispatch }, data) {
			await updateCertificateTemplate(data)
			dispatch('fetchTemplates')
		},
		async deleteTemplate({ dispatch }, id) {
			await deleteCertificateTemplate(id)
			dispatch('fetchTemplates')
		},
		async fetchIssued({ commit }, params) {
			commit('SET_ISSUED_STATUS', 'pending')
			try {
				const { data } = await listIssuedCertificates(params)
				commit('SET_ISSUED', data)
				commit('SET_ISSUED_STATUS', 'init')
			} catch {
				commit('SET_ISSUED_STATUS', 'error')
			}
		},
		async issueCertificate(_, payload) {
			const { data } = await issueCertificate(payload)
			return data
		},
		async regeneratePdf(_, id) {
			const { data } = await regenerateCertificatePdf(id)
			return data
		},
		async previewCertificate(_, id) {
			const { data } = await previewCertificate(id)
			return data
		},
	},
}
